export const VIEW_PERMISSIONS_ROUTE_PATHS = {
  viewPermissions: '/admin/view-permissions',
};

export const AVAILABLE_PANEL_MODULES = [
  'chargebacks',
  'fraud-operations',
  'hawk-ai',
  'limit-operations',
  'user-flags',
  'med-infractions',
  'find-users',
  'kyc',
  'movements-wallets',
  'movements-debit-card-transactions',
  'movements-cashout-deposits',
  'movements-promo',
  'movements-withdrawals',
  'movements-tp-transfers',
  'movements-full-gateway',
  'movements-full-gateway-merchant',
  'movements-platform-transfers',
  'movements-top-up',
  'movements-pix-transfers',
  'view-permissions',
  'batch-processing',
  'audit-engine',
  'maker-checker',
  'users-operations',
  'communications',
  'users-tp-accounts',
  'debt-engine',
  'fx-configuration',
  'debit-card-abm',
  'debit-card-operations',
  'debit-card-product-pack',
  'gateway-routing',
  'expatriations',
  'affiliates',
  'partners-platform',
  'help-center',
  'payment-methods',
  'rules-config',
  'withdrawal-method-config',
  'treasury-credencial',
  'treasury-transfers',
];

export const MODULE_CATEGORY_MAP: Record<string, string> = {
  chargebacks: 'Fraud',
  'fraud-operations': 'Fraud',
  'hawk-ai': 'Fraud',
  'limit-operations': 'Fraud',
  'user-flags': 'Fraud',
  'med-infractions': 'Fraud',
  'find-users': 'Users',
  kyc: 'Users',
  'movements-wallets': 'Movements',
  'movements-debit-card-transactions': 'Movements',
  'movements-cashout-deposits': 'Movements',
  'movements-promo': 'Movements',
  'movements-withdrawals': 'Movements',
  'movements-tp-transfers': 'Movements TP Transfers',
  'movements-full-gateway': 'Movements',
  'movements-full-gateway-merchant': 'Movements',
  'movements-platform-transfers': 'Movements',
  'movements-top-up': 'Movements',
  'movements-pix-transfers': 'Movements',
  'view-permissions': 'Admin',
  'maker-checker': 'Maker Checker',
  'users-operations': 'Users',
  communications: 'Users',
  'users-tp-accounts': 'Users',
  'debt-engine': 'Ops Hub',
  'fx-configuration': 'Ops Hub',
  'debit-card-abm': 'Cards',
  'debit-card-operations': 'Cards',
  'debit-card-product-pack': 'Cards',
  'gateway-routing': 'Ops Hub',
  expatriations: 'Finance',
  affiliates: 'Cards',
  'partners-platform': 'Partners Platform',
  'help-center': 'Help Center',
  'payment-methods': 'Ops Hub',
  'rules-config': 'Ops Hub',
  'withdrawal-method-config': 'Ops Hub',
  'treasury-credencial': 'Treasury',
  'treasury-transfers': 'Treasury',
};
